// extracted by mini-css-extract-plugin
export default {"wrapper":"sB-z","button":"tB-z","alternate":"uB-z","disabled":"vB-z","paymentWarning":"wB-z","fadeIn":"xB-z"};